var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "root", staticClass: "split" },
    [
      _vm.closeVisible
        ? _c("el-button", {
            staticClass: "close-doc-btn",
            attrs: {
              type: "info",
              icon: "el-icon-close",
              circle: "circle",
              size: "mini",
              title: "Fechar"
            },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "pane left", style: { width: _vm.leftWidth + "px" } },
        [_vm._t("left")],
        2
      ),
      _c("div", { staticClass: "divider" }, [
        _c("div", {
          staticClass: "handle",
          attrs: { role: "separator", "aria-orientation": "vertical" },
          on: {
            mousedown: function($event) {
              $event.preventDefault()
              return _vm.startDrag($event)
            },
            touchstart: function($event) {
              $event.preventDefault()
              return _vm.startDragTouch($event)
            }
          }
        })
      ]),
      _c("div", { staticClass: "pane right" }, [_vm._t("right")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16b225fd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16b225fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppSplitPane.vue
// module id = null
// module chunks = 